import axios from 'axios';
import { API } from './apiConfig';

const authHeader = () => ({ withCredentials: true });

export const getProfile = async () => {
  const { data } = await axios.get(`${API}/profile`, authHeader());
  return data;
};

export const updateProfile = async (updates) => {
  const { data } = await axios.put(`${API}/profile`, updates, authHeader());
  return data;
};

export const getSubscriptionStatus = async () => {
  const { data } = await axios.get(`${API}/subscription-status`, authHeader());
  return data;
};

export const createCheckoutSession = async (packageId, pagePath) => {
  const { data } = await axios.post(`${API}/create-checkout-session`, { packageId, pagePath }, authHeader());
  return data;
};

export const createBillingSession = async (returnPath = '/subscription') => {
  const { data } = await axios.post(`${API}/create-billing-session`, { returnPath }, authHeader());
  return data;
};

export const getBillingReceipts = async () => {
  const { data } = await axios.get(`${API}/billing-receipts`, authHeader());
  return data;
};
